import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs, redirect } from 'react-router';
import { getAuthUser } from '~/shared/auth/auth-utils';
import { createRoutes, createSystemRoute } from '~/shared/models/create-routes';

export const baseRouterLoader =
  (queryClient: QueryClient) =>
  async ({ request }: LoaderFunctionArgs) => {
    const authUser = await getAuthUser(queryClient, request);

    if (authUser?.shouldShowSystemsList()) {
      return redirect(createRoutes.Systems);
    }

    return redirect(createSystemRoute());
  };
